module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"submit":"Update","linkToAmazon":"Link to Amazon"}}')
  delete Component.options._Ctor
}
